import { Cell, Grid } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'

import { AssinaturaRegistrosCard } from './cards/AssinaturaRegistrosCard'
import { DocumentosEnvioCidadaoCard } from './cards/DocumentosEnvioCidadaoCard'
import { DocumentosRndsCard } from './cards/DocumentosRndsCard'
import { ConfiguracaoAssinaturaDigital } from './ConfiguracaoAssinaturaDigitalBox'
import { AssinaturaDigitalModel } from './model-assinaturaDigital'

interface AssinaturaDigitalSectionProps {
  assinaturaDigital: AssinaturaDigitalModel
  internetHabilitada: boolean
  smtpConfigurado: boolean
  refetch(): void
}

export function AssinaturaDigitalSection(props: Readonly<AssinaturaDigitalSectionProps>) {
  const { assinaturaDigital, internetHabilitada, smtpConfigurado, refetch } = props
  const { ASSINATURA_ELETRONICA_ENABLED } = useFlags()
  const { documentosEnvioCidadao, assinaturaRegistros, documentosRnds } = assinaturaDigital

  return (
    <Grid>
      <Cell size={12}>
        <ConfiguracaoAssinaturaDigital
          internetHabilitada={internetHabilitada}
          assinaturaDigitalHabilitado={assinaturaDigital.habilitado}
          usuario={assinaturaDigital.usuario ?? undefined}
          senha={assinaturaDigital.senha ?? undefined}
          load={refetch}
        />
      </Cell>
      <Cell size={4}>
        <DocumentosEnvioCidadaoCard
          habilitado={documentosEnvioCidadao.habilitado}
          baseHabilitada={assinaturaDigital.habilitado}
          smtpConfigurado={smtpConfigurado}
        />
      </Cell>
      {ASSINATURA_ELETRONICA_ENABLED && assinaturaRegistros && (
        <Cell size={4}>
          <AssinaturaRegistrosCard
            habilitado={assinaturaRegistros.habilitado}
            baseHabilitada={assinaturaDigital.habilitado}
          />
        </Cell>
      )}
      <Cell size={4}>
        <DocumentosRndsCard habilitado={documentosRnds.habilitado} baseHabilitada={assinaturaDigital.habilitado} />
      </Cell>
    </Grid>
  )
}
